import type { NotificationChannelType, SessionRuleSeverity } from '@/api/sessionsApi'
import type { OptionListOption as ComboboxOption } from '@/components/ui/option-list'
import { branding } from './branding'

export const SESSION_TYPES = {
	SIGNAL: 'signal',
	NO_DATA: 'no_data',
} as const

export type SessionType = (typeof SESSION_TYPES)[keyof typeof SESSION_TYPES]

export const SESSION_TYPE_OPTIONS: ComboboxOption[] = [
	{ value: SESSION_TYPES.NO_DATA, label: 'No Signal Session' },
	{ value: SESSION_TYPES.SIGNAL, label: 'Signal Session' },
]

export const SEVERITY = {
	CRITICAL: 'critical',
	WARNING: 'warning',
	INFO: 'info',
} as const satisfies Record<string, SessionRuleSeverity>
export const SEVERITY_OPTIONS: ComboboxOption[] = [
	{ value: SEVERITY.CRITICAL, label: 'Critical' },
	{ value: SEVERITY.WARNING, label: 'Warning' },
	{ value: SEVERITY.INFO, label: 'Info' },
]

export const CHANNEL_TYPES = {
	EMAIL: 'email',
	SLACK: 'slack',
	WEBHOOK: 'webhook',
	WHATSAPP: 'whatsapp',
} as const satisfies Record<string, NotificationChannelType>

export const SESSION_RULE_DEFAULTS = {
	sessionType: SESSION_TYPES.SIGNAL,
	severity: SEVERITY.CRITICAL,
	sessionThreshold: '10',
	activationThreshold: '30',
	deactivationThreshold: '0',
	notificationInterval: '60',
	timezone: 'UTC',
	channelType: CHANNEL_TYPES.EMAIL,
}

export const DEFAULT_ACTIVATION_TEMPLATE = `{% for session in sessions %}
Session {{ session.name }} triggered at {{ session.start_time }} on device {{ session.device_id }}
From ${branding.companyName}{% if not loop.last %}

{% endif %}{% endfor %}`

export const DEFAULT_DEACTIVATION_TEMPLATE = `{% for session in sessions %}
Session {{ session.name }} resolved at {{ session.end_time }} on device {{ session.device_id }}
From ${branding.companyName}{% if not loop.last %}

{% endif %}{% endfor %}`

export const SUBSCRIBER_GROUP_NOTIFY_NOTE =
	'Only sessions that start after the group is attached will send notifications.'
